import React from 'react';
import { useParams } from 'react-router-dom';
import { isNil, prop } from 'ramda';
import QDocument from '../../_graphql/queries/documents/QDocument';
import { SCOPE_OFFER } from '../../_CONST';
import withUser from '../../withUser';
import { verifyRouteAccess } from '../helpers/routeAccess';
import DocumentForm from './components/document/DocumentForm';
import RawDocumentForm from './components/rawDocument/RawDocumentForm';
import { commentsMode } from './components/helpers/elements';

const EditOfferDocument = ({ breadcrumb, userTeam }) => {
  const { offerId, documentId } = useParams();
  return (
    <QDocument args={{ documentId }}>
      {data => {
        const { document = {}, rawDocument = {} } = data;
        const accessDeniedDocument = verifyRouteAccess(userTeam, document, 'ce document', true);
        const accessDeniedRawDocument = verifyRouteAccess(userTeam, rawDocument, 'ce document');
        if (accessDeniedDocument && isNil(prop('id', rawDocument))) return accessDeniedDocument;
        if (accessDeniedRawDocument && isNil(prop('id', document))) return accessDeniedRawDocument;

        if (rawDocument) {
          return (
            <RawDocumentForm
              rawDocumentId={documentId}
              rawDocument={rawDocument}
              offerId={offerId}
            />
          );
        }
        return (
          <DocumentForm
            document={document}
            scope={SCOPE_OFFER}
            offerId={offerId}
            commentsMode={commentsMode(document)}
            breadcrumb={breadcrumb}
            cacheKey={['offerViewCache', `widgets-${offerId}`]}
          />
        );
      }}
    </QDocument>
  );
};

export default withUser(EditOfferDocument);
